var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-table-head-sort",attrs:{"role":"button"},on:{"click":_vm.sortChange}},[_vm._t("default"),_c('z-icon',{class:[
      'sort-icon',
      { 'order-asc': _vm.order === 'asc', 'order-desc': _vm.order === 'desc' }
    ],attrs:{"name":"Sort","size":"16","data-test-id":"asc-icon"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }